import { classNames } from "primereact/utils";
import { AppDialog } from "../../../common/components/AppDialog/AppDialog";
import { ItemsList } from "../../../common/components/itemsList/ItemsList";
import { ConsentItem } from "./components/ConsentItem";
import { ConsentDetailsDialog } from "./components/ConsentDetailsDialog";
import { ConsentPolicyTypeLabels } from "../../../common/labels";
import { useMyConsents } from "./hooks/useMyConsents";
import styles from "./MyConsents.module.scss";
import { RenderWhen } from "../../../common/infrastructure/components/RenderWhen";

export const MyConsents = () => {
  const {
    unsignedConsents,
    currentConsents,
    pastConsents,
    isLoading,
    selectedConsent,
    isDesktopOrTablet,
    handleOpenDialog,
    handleCloseDialog,
  } = useMyConsents();

  return (
    <>
      {/* Unsigned Consents Section (both required and optional) */}
      {unsignedConsents.length > 0 && (
        <ItemsList
          isLoading={isLoading}
          className={styles.section}
          title="Чакащи съгласия"
          noItemsText=""
          items={unsignedConsents}
          itemTemplate={(item, index) => (
            <ConsentItem
              key={index}
              item={item}
              isLoading={isLoading}
              onClick={handleOpenDialog}
            />
          )}
          enableSearch={false}
          fullHeight={false}
        />
      )}

      {/* Current Consents Section */}
      <ItemsList
        isLoading={isLoading}
        className={styles.section}
        title="Настоящи съгласия"
        noItemsText="Няма настоящи съгласия."
        items={currentConsents}
        itemTemplate={(item, index) => (
          <ConsentItem
            key={index}
            item={item}
            isLoading={isLoading}
            onClick={handleOpenDialog}
          />
        )}
        enableSearch={false}
        fullHeight={false}
      />

      {/* Past Consents Section */}

      <RenderWhen condition={pastConsents.length > 0}>
        <ItemsList
          isLoading={isLoading}
          className={styles.section}
          title="Минали съгласия"
          noItemsText="Няма минали съгласия."
          items={pastConsents}
          itemTemplate={(item, index) => (
            <ConsentItem
              key={index}
              item={item}
              isLoading={isLoading}
              onClick={handleOpenDialog}
            />
          )}
          enableSearch={false}
          fullHeight={false}
        />
      </RenderWhen>

      {/* Details Dialog */}
      <AppDialog
        header={
          selectedConsent ? ConsentPolicyTypeLabels[selectedConsent.type] : ""
        }
        visible={!!selectedConsent}
        onHide={handleCloseDialog}
        style={{ width: isDesktopOrTablet ? "650px" : "90vw" }}
        headerClassName={classNames(
          styles.root_dialog,
          styles.root_dialog_header,
        )}
        contentClassName={classNames(
          styles.root_dialog,
          styles.root_dialog_content,
        )}
      >
        <ConsentDetailsDialog
          consent={selectedConsent}
          onHide={handleCloseDialog}
        />
      </AppDialog>
    </>
  );
};
